// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Kr0rX","notes":"Notes_notes__2Li72","note":"Notes_note__24T1q","markdown":"Notes_markdown__1DvZR"};